

export const resetCreateNewJobReducer = (state) => {
    state.createNewJob.status = "idle";
    state.createNewJob.errorMessage = "";
}